import React from 'react';
import SettingCard from './SettingCard';
import { panelLabel } from '../../utils/panelLabels';

const VolumeSetup = ({ getSettingValue, handleEdit }) => {
  const volumeSettings = [
    { name: 'garner_size', label: 'Garner Size' },
    { name: 'hot_zone_volume', label: 'Hot Zone Volume' },
    { name: 'cold_zone_volume', label: 'Cold Zone Volume' },
    { name: 'throughput_rate', label: 'Throughput Rate' }
  ];
  
  return (
    <div className="grid grid-cols-2 gap-4">
      {volumeSettings.map((setting) => {
        const settingData = getSettingValue(setting.name);
        return (
          <SettingCard
            key={setting.name}
            name={panelLabel(setting.name, setting.label)}
            value={settingData.value}
            min={settingData.minRange}
            max={settingData.maxRange}
            onEdit={(_, value) => handleEdit(setting.name, value)}
          />
        );
      })}
    </div>
  );
};

export default VolumeSetup;